'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserHeaderActions = require('./components/UserHeaderActions.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UserHeaderActions).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-header/lib/components/user-header-actions/index.js
// module id = 1552
// module chunks = 1